var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-loading" }, [
      _c("span", { staticClass: "loading" }, [
        _c("span", { staticClass: "bar bar1" }),
        _vm._v(" "),
        _c("span", { staticClass: "bar bar2" }),
        _vm._v(" "),
        _c("span", { staticClass: "bar bar3" }),
        _vm._v(" "),
        _c("span", { staticClass: "bar bar4" }),
        _vm._v(" "),
        _c("span", { staticClass: "bar bar5" }),
        _vm._v(" "),
        _c("span", { staticClass: "bar bar6" }),
        _vm._v(" "),
        _c("span", { staticClass: "bar bar7" }),
        _vm._v(" "),
        _c("span", { staticClass: "bar bar8" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-987a45c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-987a45c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/chat/src/loading.vue
// module id = null
// module chunks = 